import axios from "@/services/vue-axios";
import { i18n } from "@/services/vue-i18n";

export default {
  init() {
    console.info("Toolbox/AdvancedForms module initialized.");
  },

  // Tool operations
  clear({ commit }) {
    commit("clear");
  },
  /**
   * Action avalaible for validating forms without the intention of posting data.
   */
  validate({ commit, dispatch }) {
    // Reset the status message and validations
    dispatch(
      "system/setStatus",
      {
        type: "",
        message: ""
      },
      { root: true }
    );
    commit("resetValidations");
    // Valid until proven otherwise
    commit("valid", true);
    // This should raise an event (watch) in the form components
    commit("validating", true);
  },

  /**
   * This is where components submit their form's validation when asked via the 'validating' state.
   * @param {Boolean} valid If the validation submitted turned out to be valid
   */
  submitValidation({ state, commit, dispatch }, valid) {
    // Stop the validation process the moment a validation did not pass
    if (!valid) {
      commit("addError");
      // Can potentially be confusing at first. This is the 'valid' for the whole validation.
      commit("valid", false);
      dispatch(
        "system/setStatus",
        {
          type: "error",
          message: i18n.tc("validation.advanced-forms.fix", state.errors)
        },
        { root: true }
      );
    } else {
      commit("addValidation");
    }

    // The number of forms in the validation process
    var size = state.data.length;
    if (Number.isInteger(state.fixedSize) && state.fixedSize > 0) {
      size = state.fixedSize;
    }

    if (state.validations + state.errors === size) {
      commit("validating", false);
    }
  },

  // Backend Operations

  /**
   * Fetching will use data from the initialized state 'fetchEndpoint'.
   */
  fetch({ state, commit }) {
    commit("clearData");
    commit("fetching", true);

    axios
      .get(state.fetchEndpoint)
      .then(response => {
        const data = response.data[Object.keys(response.data)[0]];
        data.forEach(function(item) {
          item.id = state.counter;
          commit("count");
          state.adapter.in(item).then(res => commit("add", res));
        });
        commit("updateReference");
        commit("fetching", false);
      })
      .catch(error => {
        if (process.env.NODE_ENV !== "production") {
          console.log(error);
        }
      });
  },
  /**
   * This action is responsible for posting the data to the backend.
   */
  async send({ state, commit, dispatch }) {
    var payload = [];
    const worker = new Promise(resolve => {
      var adapted = [];
      state.data.forEach(function(item) {
        state.adapter.out(item).then(res => adapted.push(res));
      });
      resolve(adapted);
    });
    worker.then(res => {
      payload = res;
      // Put the header (array's key)
      if (state.adapter.out_header !== "") {
        payload = {
          [state.adapter.out_header]: payload
        };
      }
      // Add the options
      for (var key in state.adapter.out_options) {
        // skip loop if the property is from prototype
        // eslint-disable-next-line no-prototype-builtins
        if (!state.adapter.out_options.hasOwnProperty(key)) continue;
        var value = state.adapter.out_options[key];
        payload[key] = value;
      }
      commit("sending", true);

      axios({
        method: state.method,
        url: state.sendEndpoint,
        data: payload,
        withCredentials: true,
        credentials: "include",
        mode: "cors"
      })
        .then(request => submitSuccessful(request.data))
        .catch(error => submitFailed(error));
    });

    var submitSuccessful = function(req) {
      commit("updateReference");
      commit("sending", false);
      dispatch(
        "system/setStatus",
        {
          type: "success",
          message: i18n.t("app.actions.success.update")
        },
        { root: true }
      );
    };

    var submitFailed = function(error) {
      commit("sending", false);
      dispatch(
        "system/setStatus",
        {
          type: "error",
          message: i18n.t("app.actions.failed.update")
        },
        { root: true }
      );
      if (process.env.NODE_ENV !== "production") {
        console.log(error.response);
      }
    };
  },

  // Utilities
  setFetchEndpoint({ commit }, endpoint) {
    commit("fetchEndpoint", endpoint);
  },
  setSendEndpoint({ commit }, endpoint) {
    commit("sendEndpoint", endpoint);
  },
  setSendMethod({ commit }, method) {
    commit("sendMethod", method);
  },
  setAdapterIn({ commit }, adapter) {
    commit("adapter_in", adapter);
  },
  setAdapterOut({ commit }, adapter) {
    commit("adapter_out", adapter);
  },
  setAdapterOutHeader({ commit }, header) {
    commit("adapter_out_header", header);
  },
  setOption({ commit }, option) {
    commit("adapter_out_option", option);
  },

  // Validation
  setFixedSize({ commit }, size) {
    commit("fixedSize", size);
  },

  // Undo/Redo
  updateItem({ commit }, data) {
    commit("update", data);
  },
  removeItem({ commit }, id) {
    commit("remove", id);
  },
  pushState({ commit }, data) {
    commit("push", data);
  },
  pushMany({ state, commit }, data) {
    var dataCopy = Array.from(state.data);
    data.forEach(function(item) {
      item.id = state.counter;
      commit("count");
      dataCopy.push(item);
    });
    commit("push", dataCopy);
  },
  undoState({ commit }) {
    commit("undo");
  },
  redoState({ commit }) {
    commit("redo");
  }
};
